import { gql } from "@apollo/client";

export const GET_FRANCHISE_DEPOSITE = gql`
query GetFranchiseDepositeForAdmin($franchiseId: ID, $sort: orderSort, $page: Int, $limit: Int, $from: String, $to: String, $search: String) {
  getFranchiseDepositeForAdmin(franchiseId: $franchiseId, sort: $sort, page: $page, limit: $limit, from: $from, to: $to, search: $search) {
    count
    data {
      id
      franchiseId
      amount
      transactionId
      photo
      createdAt
      pdfUrl
    }
  }
}
`